// extracted by mini-css-extract-plugin
export var formContainer = "_e4-0";
export var message = "_e4-1";